import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { WorkflowDto } from '../../dtos/workflow-dto.interface';

@UntilDestroy()
@Component({
    selector: 'closing-workflows-table',
    templateUrl: './closing-workflows-table.component.html',
    styleUrls: ['./closing-workflows-table.component.scss'],
})
export class ClosingWorkflowsTableComponent implements AfterViewInit {
    openWorkflowDeletionConfirmationDialog = false;
    workflowIdToDelete: string | undefined;

    private _workflows: WorkflowDto[] = [];
    @Input()
    set workflows(value: WorkflowDto[]) {
        this._workflows = value || [];
        setTimeout(() => {
            this.updateTableHeight();
            this.cdr.detectChanges();
        });
    }
    get workflows(): WorkflowDto[] {
        return this._workflows;
    }

    @ViewChild('pageWrapper') pageWrapper!: ElementRef;
    private readonly DEFAULT_TABLE_HEIGHT = 200;

    @Output() editWorkflow = new EventEmitter<string>();
    @Output() deleteWorkflow = new EventEmitter<string>();

    constructor(private readonly cdr: ChangeDetectorRef) { }
    ngAfterViewInit(): void {
        this.updateTableHeight();
        this.cdr.detectChanges();
    }

    @HostListener('window:resize', [])
    onWindowResize(): void {
        this.updateTableHeight();
    }

    private updateTableHeight(): void {
        if (this.pageWrapper && this.pageWrapper.nativeElement) {
            const pageWrapperElement = this.pageWrapper.nativeElement as HTMLElement;
            const rect = pageWrapperElement.getBoundingClientRect();
            const distanceFromTop = rect.top;
            const staticHeightOfTopNavBar = 35; // Adjust if needed
            const availableHeight = window.innerHeight - distanceFromTop - staticHeightOfTopNavBar;
            const tableMaxHeight = Math.max(this.DEFAULT_TABLE_HEIGHT, availableHeight);
            pageWrapperElement.style.setProperty('--ham-table-max-h', `${tableMaxHeight}px`);
        }
    }

    onRowSelected(row: WorkflowDto): void {
        this.editWorkflow.emit(row.workflowId);
        setTimeout(() => {
            this.updateTableHeight();
            this.cdr.detectChanges();
        });
    }

    onDeleteClick(id: string, event: MouseEvent): void {
        event.stopPropagation(); // Prevents triggering the row click
        this.openWorkflowDeletionConfirmationDialog = true;
        this.workflowIdToDelete = id;
        setTimeout(() => {
            this.updateTableHeight();
            this.cdr.detectChanges();
        });
    }

    onCancelWorkflowDeletion(): void {
        this.openWorkflowDeletionConfirmationDialog = false;
        this.workflowIdToDelete = undefined;
        setTimeout(() => {
            this.updateTableHeight();
            this.cdr.detectChanges();
        });
    }

    onDeleteRow(): void {
        this.deleteWorkflow.emit(this.workflowIdToDelete);
        this.openWorkflowDeletionConfirmationDialog = false;
        this.workflowIdToDelete = undefined;
        setTimeout(() => {
            this.updateTableHeight();
            this.cdr.detectChanges();
        });
    }
}
